import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';

const routes: Routes = [
    {
        'path': '',
        'component': ThemeComponent,
        'canActivate': [AuthGuard],
        'canActivateChild': [AuthGuard],
        'children': [
            {
                'path': 'index',
                'loadChildren': () => import('./pages/home/home.module').then(m => m.HomeModule),
            },
            {
                'path': 'captive-portal',
                'loadChildren': () => import('./pages/captive-portal/captive-portal.module').then(m => m.CaptivePortalModule),
            },
            {
                'path': 'captive-portal\/pages',
                'loadChildren': () => import('./pages/captive-portal/list/list.module').then(m => m.ListModule),
            },
            {
                'path': 'captive-portal\/pages\/:captiveId',
                'loadChildren': () => import('./pages/captive-portal/list/list.module').then(m => m.ListModule),
            },
            {
                'path': 'editor\/:pageId',
                'loadChildren': () => import('./pages/editor/editor.module').then(m => m.EditorModule),
            },
            {
                'path': 'captive-portal\/strategies',
                'loadChildren': () => import('./pages/captive-portal/strategies/strategies.module').then(m => m.StrategiesModule),
            },
            {
                'path': '',
                'redirectTo': 'index',
                'pathMatch': 'full',
            },
            {
                'path': 'administration',
                "loadChildren": () => import('./pages/administration/administration.module').then(m => m.AdministrationModule),
            },
            {
                "path": "administration\/tenants",
                "loadChildren": () => import('./pages/administration/tenants/tenants.module').then(m => m.TenantsModule),
            },
            {
                "path": "administration\/channel",
                "loadChildren": () => import('./pages/administration/channel/channel.module').then(m => m.ChannelModule),
            },
            {
                "path": "administration\/email-senders",
                "loadChildren": () => import('./pages/administration/email-senders/email-senders.module').then(m => m.EmailSendersModule),
            },
            {
                "path": "administration\/tenants\/:tenant_id\/email-templates",
                "loadChildren": () => import('./pages/administration/tenants/email-templates/email-templates.module').then(m => m.EmailTemplatesModule),
            },
            {
                "path": "administration\/tenants\/:tenant_id\/email-templates\/:template_id",
                "loadChildren": () => import('./pages/administration/tenants/email-templates/alter/alter.module').then(m => m.EmailTemplatesAlterModule),
            },
            {
                "path": "administration\/tenants\/:tenant_id\/services",
                "loadChildren": () => import('./pages/administration/tenants/services/services.module').then(m => m.ServicesModule),
            },
            {
                "path": "administration\/tenants\/:tenant_id\/services\/:new_service",
                "loadChildren": () => import('./pages/administration/tenants/services/alter/alter.module').then(m => m.AlterModule),
            },
            {
                "path": "administration\/tenants\/:tenant_id\/services\/:service_id\/:service_type",
                "loadChildren": () => import('./pages/administration/tenants/services/alter/alter.module').then(m => m.AlterModule),
            },
            {
                "path": "administration\/email-models",
                "loadChildren": () => import('./pages/administration/email-models/email-models.module').then(m => m.EmailModelsModule),
            },
            {
                'path': 'administration\/user_groups',
                "loadChildren": () => import('./pages/administration/user-groups/user-groups.module').then(m => m.UserGroupsModule),
            },
            {
                'path': 'administration\/policies',
                "loadChildren": () => import('./pages/administration/policies/policies.module').then(m => m.PoliciesModule),
            },
            {
                'path': 'administration\/location-groups',
                "loadChildren": () => import('./pages/administration/location-groups/location-groups.module').then(m => m.LocationGroupsModule),
            },
            {
                'path': 'administration\/locations',
                "loadChildren": () => import('./pages/administration/locations/locations.module').then(m => m.LocationsModule),
            },
            {
                'path': 'administration\/create-location',
                "loadChildren": () => import('./pages/administration/locations/create/create.module').then(m => m.CreateLocationsModule),
            },
            {
                'path': 'administration\/create-location\/:location_id',
                "loadChildren": () => import('./pages/administration/locations/create/create.module').then(m => m.CreateLocationsModule),
            },
            {
                'path': 'administration\/locations\/:location_group_id',
                "loadChildren": () => import('./pages/administration/locations/locations.module').then(m => m.LocationsModule),
            },
            {
                'path': 'administration\/locations\/inventory\/:location_id',
                "loadChildren": () => import('./pages/administration/locations/inventory/inventory.module').then(m => m.InventoryModule),
            },
            {
                'path': 'administration\/radius',
                "loadChildren": () => import('./pages/administration/radius/radius.module').then(m => m.RadiusModule),
            },
            {
                'path': 'administration\/captive-portal',
                "loadChildren": () => import('./pages/administration/captive-portal/captive-portal.module').then(m => m.CaptivePortalModule),
            },
            {
                'path': 'administration\/strategies',
                "loadChildren": () => import('./pages/administration/strategies/strategies.module').then(m => m.StrategiesModule),
            },
            {
                'path': 'administration\/network-device-interface',
                "loadChildren": () => import('./pages/administration/network-device-interface/network-device-interface.module').then(m => m.NetworkDeviceInterfaceModule),
            },
            {
                'path': 'analytics',
                "loadChildren": () => import('./pages/analytics/analytics.module').then(m => m.AnalyticsModule),
            },
            {
                'path': 'analytics\/access-statistics',
                "loadChildren": () => import('./pages/analytics/access-statistics/access-statistics.module').then(m => m.AccessStatisticsModule),
            },
            {
                "path": "analytics\/access-statistics\/1",
                "loadChildren": () => import('./pages/analytics/access-statistics/access-statistics.1/access-statistics.1.module').then(m => m.AccessStatistics1Module)
            },
            {
                "path": "analytics\/access-statistics\/2",
                "loadChildren": () => import('./pages/analytics/access-statistics/access-statistics.2/access-statistics.2.module').then(m => m.AccessStatistics2Module)
            },
            {
                'path': 'analytics\/connection-statistics',
                "loadChildren": () => import('./pages/analytics/connection-statistics/connection-statistics.module').then(m => m.ConnectionStatisticsModule),
            },
            {
                'path': 'analytics\/connection-statistics\/1',
                "loadChildren": () => import('./pages/analytics/connection-statistics/connection-statistics.1/connection-statistics.1.module').then(m => m.ConnectionStatistics1Module),
            },
            {
                'path': 'analytics\/connection-statistics\/2',
                "loadChildren": () => import('./pages/analytics/connection-statistics/connection-statistics.2/connection-statistics.2.module').then(m => m.ConnectionStatistics2Module),
            },
            {
                'path': 'analytics\/connection-statistics\/3',
                "loadChildren": () => import('./pages/analytics/connection-statistics/connection-statistics.3/connection-statistics.3.module').then(m => m.ConnectionStatistics3Module),
            },
            {
                'path': 'analytics\/traffic-statistics',
                "loadChildren": () => import('./pages/analytics/traffic-statistics/traffic-statistics.module').then(m => m.TrafficStatisticsModule),
            },
            {
                "path": "analytics\/traffic-statistics\/1",
                "loadChildren": () => import('./pages/analytics/traffic-statistics/traffic-statistics.1/traffic-statistics.1.module').then(m => m.TrafficStatistics1Module)
            },
            {
                "path": "device",
                'loadChildren': () => import('./pages/device/device.module').then(m => m.DeviceModule),
            },
            {
                "path": "device\/vendor",
                'loadChildren': () => import('./pages/device/vendor/vendor.module').then(m => m.VendorModule)
            },
            {
                "path": "sessions",
                'loadChildren': () => import('./pages/monitoring/sessions/sessions.module').then(m => m.SessionsModule)
            },
            {
                "path": "profiles",
                'loadChildren': () => import('./pages/monitoring/profile/profile.module').then(m => m.ProfileModule)
            },
            {
                "path": "404",
                "loadChildren": () => import('./pages/default/blank/blank.module').then(m => m.BlankModule)
            }
        ],
    },
    {
        'path': '**',
        'redirectTo': 'index',
        'pathMatch': 'full',
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ThemeRoutingModule { }
